import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './StoresModal.module.scss';

function StoresModal(props) {
  const columns = [
    {
      text: 'Name',
      dataField: 'name',
      editable: false,
    },
    {
      text: 'Address',
      dataField: 'address1',
      editable: false,
    },
    {
      text: 'City',
      dataField: 'city',
      editable: false,
    },
    {
      text: 'Country',
      dataField: 'country',
      editable: false,
    },
    {
      text: 'ZIP Code',
      dataField: 'zip_code',
      editable: false,
    },
    {
      text: 'Account ID',
      dataField: 'erp_id',
      classes: 'editable',
    },
  ];

  const cellEdit = cellEditFactory({
    mode: 'click',
    blurToSave: true,
    afterSaveCell: (oldValue, newValue, row, column) => {
      if (oldValue !== newValue) {
        props.saveErpId({ erp_id: newValue }, row.id);
      }
    },
  });

  return (
    <ModalWindow open={props.open} onClose={props.onClose} showCloseIcon={false} center>
      <h2>{props.name} Stores</h2>
      <hr />
      <div className={styles.body}>
        <div className={styles.table}>
          <BootstrapTable
            data={props.stores}
            columns={columns}
            keyField="id"
            printable
            striped
            bordered={false}
            hover
            className={styles.container}
            cellEdit={cellEdit}
          ></BootstrapTable>
        </div>
      </div>
      <hr />
      <div className={styles.footer}>
        <div className={styles.buttons}>
          <Button color="white" text="CLOSE" onClick={props.onClose} />
        </div>
      </div>
    </ModalWindow>
  );
}

export default StoresModal;

StoresModal.defaultProps = {
  open: false,
};

StoresModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  stores: PropTypes.arrayOf(PropTypes.object).isRequired,
  name: PropTypes.string.isRequired,
  saveErpId: PropTypes.func.isRequired,
};
